import { render, staticRenderFns } from "./GrantApplicationDetails.vue?vue&type=template&id=6d4bc7dc&scoped=true&"
import script from "./GrantApplicationDetails.vue?vue&type=script&lang=ts&"
export * from "./GrantApplicationDetails.vue?vue&type=script&lang=ts&"
import style0 from "./GrantApplicationDetails.vue?vue&type=style&index=0&id=6d4bc7dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bc7dc",
  null
  
)

export default component.exports